// extracted by mini-css-extract-plugin
module.exports = {"PlaceItem":"Place_PlaceItem__WCUWp","Image":"Place_Image__1RhRI","PlaceTitle":"Place_PlaceTitle__3u9td"};